import React from 'react';
import DOMPurify from 'dompurify';
import type { question } from '@/features/simulationConfiguration/types.api';
import styles from './QuestionDisplay.module.css';

interface QuestionDisplayProps {
    question: question;
    selectedAnswer: string | undefined;
    onAnswerChange: (questionId: number, answer: string) => void;
}

const QuestionDisplay: React.FC<QuestionDisplayProps> = ({ question, selectedAnswer, onAnswerChange }) => {
    if (!question) {
        return <div className={styles.loadingQuestion}>Cargando pregunta...</div>;
    }

    if (!question.content || !question.content.options || question.content.options.length === 0) {
        return (
            <div className={styles.loadingQuestion}>
                <div>Pregunta sin opciones configuradas.</div>
            </div>
        );
    }

    const sanitizedText = DOMPurify.sanitize(question.content.text || '');
    const options = question.content.options || [];

    return (
        <div className={styles.questionContainer}>
            <div className={styles.questionContent}>
                <div
                    className={styles.questionText}
                    dangerouslySetInnerHTML={{ __html: sanitizedText }}
                />
                {question.content.image_url && (
                    <div className={styles.imageWrapper}>
                        <img src={question.content.image_url} alt={`Imagen para la pregunta ${question.content.session_question_number}`} />
                    </div>
                )}
            </div>

            <div className={styles.optionsContainer}>
                {options.map(option => {
                    const sanitizedOptionText = DOMPurify.sanitize(option.text);
                    return (
                        <button
                            key={option.key}
                            className={`${styles.optionButton} ${selectedAnswer === option.key ? styles.selected : ''}`}
                            onClick={() => onAnswerChange(question.id, option.key)}
                        >
                            <span className={styles.optionKey}>{option.key}</span>
                            <span
                                className={styles.optionText}
                                dangerouslySetInnerHTML={{ __html: sanitizedOptionText }}
                            />
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default QuestionDisplay;
